"use client";

import React, {useState, useEffect} from 'react';

import {useRouter} from 'next/navigation';

import {Box, LinearProgress, Button} from '@mui/material';
import Grid from '@mui/material/Grid2';

import Cookies from 'js-cookie';

import {useAuthStatus} from '@/app/_contexts/AuthStatusContext';


export default function Root() {
    const router = useRouter();

    const {isAuthenticated, isStaff, isSuperuser} = useAuthStatus();


    useEffect(() => {
        if (isAuthenticated) {
            // Redirect to a protected route if the user is authenticated
            router.push('/home'); // change '/home' to wherever you want to redirect the authenticated user
        }
    }, [isAuthenticated, router]);


    if (!isAuthenticated) {
        return (
            <>
            </>
        );
    }

    return null; // Return null or any other fallback UI
}
